import Decimal           from 'decimal.js';
import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";

import Numeric           from '@/core/types/Numeric';

/**
 * Цена для Техно: Техно считает сумму строки как цена × количество, и при
 * трёх знаках копейки расходятся. Зеркало бекового PricePrecise.
 */
@Title_ru_RU_Class('Цена')
class PricePrecise extends Numeric {
  static readonly SCALE = 12;

  static fromServer(value: string): PricePrecise {
    return new PricePrecise(value);
  }

  static fromOperation(value: Decimal): PricePrecise {
    return new PricePrecise(value);
  }
}

export default PricePrecise;
